export { default as denyRequest } from './denyRequest';


// WEBPACK FOOTER //
// ./src/components/userSearchResults/api/index.js